import { connect } from 'react-redux';
import CreateAssignmentModal from './CreateAssignmentModal';
import { operations as assignmentOperations } from '../../../../../store/assignments';
import { spacesInWhichInstructor } from '../../../../../utils/user';
import { currentUser } from '../../../../../../core/selectors/user';
import { baseDomain } from '../../../../../../core/selectors/institution';
import {
  isTurnItInEnabled,
  tiiMaxGrade,
} from '../../../../../../core/selectors/lti';

const editAssignment = (user, tool, space, assignment, accessToken) =>
  assignmentOperations.editAssignment({
    currentUser: user,
    spaceId: space.objectId,
    assignment: {
      ...assignment,
      provider: tool,
    },
    accessToken, // get token from fetchAccessToken
  });

const createAssignment = (user, tool, space, assignment, accessToken) =>
  assignmentOperations.createAssignment({
    currentUser: user,
    spaceId: space.objectId,
    assignment: {
      ...assignment,
      provider: tool,
      status: 'live',
    },
    accessToken, // get token from fetchAccessToken
  });

const mapStateToProps = (state) => {
  // filter the classes in which user is instructor
  const spaces = spacesInWhichInstructor();
  const user = currentUser(state);

  return {
    user,
    spaces,
    isTurnitinEnabled: isTurnItInEnabled(state),
    tiiMaxGrade: tiiMaxGrade(state),
    baseDomain: baseDomain(state),
  };
};

const mapDispatchToProps = {
  editAssignment,
  createAssignment,
};

const CreateAssignmentModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAssignmentModal);

export default CreateAssignmentModalContainer;
